/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { MailboxResponse } from './mailboxResponse';

export interface MailboxList {
  mailboxes: MailboxResponse[];
}
